import { render, staticRenderFns } from "./copyable.vue?vue&type=template&id=81f2110e&scoped=true&"
import script from "./copyable.vue?vue&type=script&lang=js&"
export * from "./copyable.vue?vue&type=script&lang=js&"
import style0 from "./copyable.vue?vue&type=style&index=0&id=81f2110e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f2110e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
